import { campaignAccessSymbol } from "#shared/symbols";
import type { Permission } from "#shared/permissions";

export function usePermissions() {
  const { user } = useUserSession();

  const isAdmin = computed(() =>
    Boolean(user.value?.isAdmin || user.value?.isSuperuser),
  );
  const isSuperuser = computed(() => Boolean(user.value?.isSuperuser));

  const access = inject(
    campaignAccessSymbol,
    ref<Permission[] | "admin" | undefined>(undefined),
  );

  const can = (permission: Permission) =>
    isAdmin.value ||
    access.value === "admin" ||
    (Array.isArray(access.value) && access.value.includes(permission));

  const canAny = (...permissions: Permission[]) => permissions.some(can);

  return { isAdmin, isSuperuser, access, can, canAny };
}
